import './HowItWorks.css';

const steps = [
  {
    number: '01',
    icon: '🤝',
    color: '#5B80F5',
    title: 'Co-construisez les tâches ensemble',
    desc: 'Asseyez-vous avec votre enfant et créez ensemble ses missions. En 20 à 60 secondes par tâche, il s\'approprie ce qu\'il s\'engage à faire.',
    details: ['✏️ Titre personnalisé', '🐱 Avatar choisi', '⏰ Durée & récurrence', '⭐ Difficulté co-évaluée'],
  },
  {
    number: '02',
    icon: '✅',
    color: '#34C78A',
    title: 'L\'enfant valide ses missions',
    desc: 'Une fois par jour, l\'enfant retrouve la liste de ses missions. Il les valide en un geste et reçoit immédiatement ses marqueurs d\'évolution.',
    details: ['⏱️ Timer visuel', '👆 Validation en un geste', '💌 Message bienveillant', '⚡ Points d\'XP immédiats'],
  },
  {
    number: '03',
    icon: '📈',
    color: '#F59E0B',
    title: 'Suivez la progression ensemble',
    desc: 'Débloquez les récompenses et célébrez les paliers franchis. La progression devient visible et concrète — pour toute la famille.',
    details: ['🏆 Niveaux et paliers XP', '🃏 Collections de cartes', '🐾 Mascottes évolutives', '📊 Stats par enfant'],
  },
];

export default function HowItWorks() {
  return (
    <section className="hiw" id="fonctionnement">
      <div className="hiw__bg" />

      <div className="container">
        <div className="hiw__header">
          <div className="section-label">⚙️ Comment ça marche ?</div>
          <h2 className="section-title">Simple. Rapide. Efficace.</h2>
          <p className="section-subtitle">
            Evolify s'intègre en douceur dans votre quotidien. Moins de 2 minutes par jour suffisent pour transformer les routines de votre enfant.
          </p>
        </div>

        {/* Étapes avec connecteurs fléchés */}
        <div className="hiw__steps">
          {steps.flatMap((step, i) => {
            const card = (
              <div key={step.number} className="hiw__step-card" style={{ '--step-color': step.color }}>

                {/* Badge + numéro décoratif */}
                <div className="hiw__step-top">
                  <span className="hiw__step-badge">ÉTAPE {step.number}</span>
                  <span className="hiw__step-num">{step.number}</span>
                </div>

                {/* Icône verre dépoli */}
                <div className="hiw__step-icon-wrap">
                  <span className="hiw__step-icon">{step.icon}</span>
                </div>

                {/* Texte */}
                <div className="hiw__step-body">
                  <h3 className="hiw__step-title">{step.title}</h3>
                  <p className="hiw__step-desc">{step.desc}</p>
                </div>

                {/* Tags blancs */}
                <ul className="hiw__step-details">
                  {step.details.map((d, j) => (
                    <li key={j}>{d}</li>
                  ))}
                </ul>
              </div>
            );

            if (i < steps.length - 1) {
              return [
                card,
                <div key={`conn-${i}`} className="hiw__connector">
                  <div className="hiw__connector-arrow">→</div>
                </div>,
              ];
            }
            return [card];
          })}
        </div>

        {/* Barre highlight : stat + texte + CTA */}
        <div className="hiw__highlight">
          <div className="hiw__highlight-left">
            <span className="hiw__highlight-big">2 min</span>
            <span className="hiw__highlight-label">par jour</span>
          </div>
          <div className="hiw__highlight-divider" />
          <div className="hiw__highlight-text">
            <h3 className="hiw__highlight-title">C'est tout ce qu'il faut</h3>
            <p className="hiw__highlight-sub">En moins de 2 minutes, votre enfant valide avec vous ses missions et construit son autonomie. Vous pouvez regarder la magie opérer dans leurs yeux.</p>
          </div>
          <a href="#contact" className="hiw__highlight-btn">Commencer gratuitement →</a>
        </div>
      </div>
    </section>
  );
}
